import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	restricted: {
		id: 'servicedesk-request-type-security.config-button.restricted',
		defaultMessage: 'Restrictions apply on this request type',
		description: 'Text for the request type permission button to show it is restricted.',
	},
	restrictedV2: {
		id: 'servicedesk-request-type-security.config-button.restricted-v-2',
		defaultMessage: 'Manage restrictions, restrictions applied',
		description: 'Text for the request type permission button to show it is restricted.',
	},
	restrictedTooltip: {
		id: 'servicedesk-request-type-security.config-button.restricted-tooltip',
		defaultMessage: 'Only specific people can raise this request',
		description: 'Text for the request type permission button tooltip to show it is restricted.',
	},
	restrictedTooltipV2: {
		id: 'servicedesk-request-type-security.config-button.restricted-tooltip-v-2',
		defaultMessage: 'Only specific people can raise or view this issue',
		description: 'Text for the request type permission button tooltip to show it is restricted.',
	},
	restrictedTooltipV2IssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.restricted-tooltip-v-2-issue-term-refresh',
		defaultMessage: 'Only specific people can raise or view this work item',
		description: 'Text for the request type permission button tooltip to show it is restricted.',
	},
	restrictions: {
		id: 'servicedesk-request-type-security.config-button.restrictions',
		defaultMessage: 'Restrictions',
		description: 'Label for the request type permission button denoting it handles restrictions.',
	},
	open: {
		id: 'servicedesk-request-type-security.config-button.open',
		defaultMessage: 'No restrictions on this request type',
		description: 'Text for the request type permission button to show it is open.',
	},
	openV2: {
		id: 'servicedesk-request-type-security.config-button.open-v-2',
		defaultMessage: 'Manage restrictions, no restrictions applied',
		description: 'Text for the request type permission button to show it is open.',
	},
	openTooltip: {
		id: 'servicedesk-request-type-security.config-button.open-tooltip',
		defaultMessage: 'Anyone can raise this request',
		description: 'Text for the request type permission button tooltip to show it is open.',
	},
	openTooltipV2: {
		id: 'servicedesk-request-type-security.config-button.open-tooltip-v-2',
		defaultMessage: 'Anyone can raise or view this issue',
		description: 'Text for the request type permission button tooltip to show it is open.',
	},
	openTooltipV2IssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.open-tooltip-v-2-issue-term-refresh',
		defaultMessage: 'Anyone can raise or view this work item',
		description: 'Text for the request type permission button tooltip to show it is open.',
	},
	emailChannelWarningPopup: {
		id: 'servicedesk-request-type-security.config-button.email-channel-warning-popup',
		defaultMessage: 'Unable to restrict request type as it’s used by email channel.',
		description:
			'Text shown in the popup when the user clicks the button to try to restrict a request type used by email.',
	},
	onboardingSpotlightHeading: {
		id: 'servicedesk-request-type-security.config-button.onboarding-spotlight-heading',
		defaultMessage: 'Manage restrictions on this request type',
		description: 'Header shown in the onboarding spotlight on restrict request type config button.',
	},
	onboardingSpotlightContent: {
		id: 'servicedesk-request-type-security.config-button.onboarding-spotlight-content',
		defaultMessage: 'Control who can raise requests by giving access to only specific people.',
		description:
			'Content shown in the onboarding spotlight on restrict request type config button.',
	},
	onboardingSpotlightConfirmButton: {
		id: 'servicedesk-request-type-security.config-button.onboarding-spotlight-confirm-button',
		defaultMessage: 'OK',
		description: 'Text show in the onboarding spotlight confirm button.',
	},
	onboardingNudgeHeading: {
		id: 'servicedesk-request-type-security.config-button.onboarding-nudge-heading',
		defaultMessage: 'Manage restrictions on this request type all in one place',
		description: 'Header shown in the onboarding spotlight on restrict request type config button.',
	},
	onboardingNudgeContent: {
		id: 'servicedesk-request-type-security.config-button.onboarding-nudge-content',
		defaultMessage:
			'Choose who has access to raise this request and view issues created with this request type for complete control.',
		description:
			'Content shown in the onboarding spotlight on restrict request type config button.',
	},
	onboardingNudgeContentIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.onboarding-nudge-content-issue-term-refresh',
		defaultMessage:
			'Choose who has access to raise this request and view work items created with this request type for complete control.',
		description:
			'Content shown in the onboarding spotlight on restrict request type config button.',
	},
	changeboardingNudgeHeading: {
		id: 'servicedesk-request-type-security.config-button.changeboarding-nudge-heading',
		defaultMessage: 'A new way to manage issue security on request types',
		description:
			'Header shown in the changeboarding spotlight on restrict request type config button.',
	},
	changeboardingNudgeHeadingIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.changeboarding-nudge-heading-issue-term-refresh',
		defaultMessage: 'A new way to manage work item security on request types',
		description:
			'Header shown in the changeboarding spotlight on restrict request type config button.',
	},
	changeboardingNudgeContent: {
		id: 'servicedesk-request-type-security.config-button.changeboarding-nudge-content',
		defaultMessage:
			'No longer do you need to add the <b>Security level</b> field to request types, now <link>control who can both view issues and raise requests</link> in one place. Plus, have better visibility of how your issue security scheme’s default level applies.',
		description:
			'Content shown in the changeboarding spotlight on restrict request type config button.',
	},
	changeboardingNudgeContentIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.changeboarding-nudge-content-issue-term-refresh',
		defaultMessage:
			'No longer do you need to add the <b>Security level</b> field to request types, now <link>control who can both view work items and raise requests</link> in one place. Plus, have better visibility of how your work item security scheme’s default level applies.',
		description:
			'Content shown in the changeboarding spotlight on restrict request type config button.',
	},
	onboardingNudgeDismissButton: {
		id: 'servicedesk-request-type-security.config-button.onboarding-nudge-dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button in the request type security onboarding',
	},
	onboardingNudgeShowMeButton: {
		id: 'servicedesk-request-type-security.config-button.onboarding-nudge-show-me-button',
		defaultMessage: 'Show me',
		description: 'Show me button in the request type security onboarding',
	},
});
